import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.to ? (
              <Link
                to={item.to}
                className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.example.com/' },
              ...items
                .filter((item) => item.to)
                .map((item, i) => ({
                  '@type': 'ListItem',
                  position: i + 2,
                  name: item.label,
                  item: `https://www.example.com${item.to}`,
                })),
              {
                '@type': 'ListItem',
                position: items.length + 2,
                name: items[items.length - 1]?.label || '',
              },
            ],
          }),
        }}
      />
    </nav>
  );
};

export default Breadcrumb;